import {request} from '@/helpers/apiClient';
import {GLOBAL_API_CONFIG} from '@/utils/constants/apiConfig/globalApiConfig';
import {TARGETS_CONFIG} from '@/utils/constants/apiConfig/targetsConfig';

export const getSalesTargetsList = (queryParams, body) =>
  request(TARGETS_CONFIG.SALES_TARGETS(queryParams), {data: body});

export const uploadFileService = (options) =>
  request(GLOBAL_API_CONFIG.FILE_UPLOAD, options);

export const getSalesTargetCsvFile = (queryParams, body) =>
  request(TARGETS_CONFIG.SALES_TARGETS_CSV_DOWNLOAD(queryParams), {data: body});

export const addSalesTargetList = (reqObj) =>
  request(TARGETS_CONFIG.ADD_SALES_TARGETS, reqObj, '');

export const getSalesTargetData = (queryParams, body) =>
  request(TARGETS_CONFIG.SALES_TARGETS_EDIT(queryParams), '', {data: body});

export const validateProductIds = (reqObj, options = {}) =>
  request(TARGETS_CONFIG.VALIDATE_PRODUCT_IDS, reqObj, '', options);

export const getSalesTargetsDownloadMedia = (queryParams) =>
  request(
    TARGETS_CONFIG.SALES_TARGETS_DOWNLOAD_IMAGE,
    {responseType: 'blob'},
    queryParams
  );
export const getSalesTargetsReporteDownload = (queryParams) =>
  request(TARGETS_CONFIG.SALES_TARGETS_REPORT_DOWNLOAD, '', queryParams);

export const getSalesTargetsReviewCSVDownload = (queryParams) =>
  request(TARGETS_CONFIG.SALES_TARGETS_REVIEW_CSV_DOWNLOAD, '', queryParams);

export const addDraftSalesTargetList = (reqObj) =>
  request(TARGETS_CONFIG.ADD_DRAFT_SALES_TARGETS, reqObj, '');

export const updateDraftSalesTargetList = (reqObj) =>
  request(TARGETS_CONFIG.UPDATE_DRAFT_SALES_TARGETS, reqObj, '');

export const updateEditSalesTargetTemplate = (id, reqObj) =>
  request(TARGETS_CONFIG.UPDATE_EDIT_TARGETS_TEMPLATE(id), {data: reqObj});

export const putSalesTarget = (id, reqObj) =>
  request(TARGETS_CONFIG.PUT_SALES_TARGET(id), {data: reqObj});

export const patchSalesTarget = (id, reqObj) =>
  request(TARGETS_CONFIG.PATCH_SALES_TARGET(id), {data: reqObj});

export const validateSalesTargetName = (queryParams) =>
  request(TARGETS_CONFIG.VALIDATE_SALES_TARGET_NAME, '', queryParams);

export const fetchLinkedSalesTargets = (body) =>
  request(TARGETS_CONFIG.LINKED_SALES_TARGETS(), {data: body});
